import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  input,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatHint } from '@angular/material/form-field';
import { SiaTranslatePipe } from '@sia/shared';
import { SiaBaseEditorSignalComponent } from '../sia-base-editor/sia-base-editor-signal.component';
import { SiaErrorHintComponent } from '../sia-error-hint/sia-error-hint.component';

@Component({
  selector: 'sia-check-box',
  templateUrl: './sia-check-box.component.html',
  styleUrls: ['./sia-check-box.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatCheckbox,
    FormsModule,
    SiaTranslatePipe,
    MatHint,
    SiaErrorHintComponent,
  ],
})
export class SiaCheckBoxComponent extends SiaBaseEditorSignalComponent {
  // @ViewChildren(MatCheckbox) matCheckBoxes?: MatCheckbox[];
  override cdr = inject(ChangeDetectorRef);

  useNull = input(false);

  // Logic from setter moved here.
  // Note: model update should happen from template or external source.
  // The original setter had logic to transform value.
  // We can intercept writes via a computed (if read-only) or just rely on the fact
  // that mat-checkbox will write boolean.
  // For 'useNull' logic, we might need to intercept the write from the template

  changeValue() {
    if (this.disabled()) {
      return;
    }
    // Logic to toggle.
    // If we assume boolean toggle:
    this.value.update((v) => !v);
  }

  // The original setter logic:
  // if (!v) v = this.useNull ? null : false;
  // if (v == this._value) return;
  // if (typeof v === 'boolean') this._value = v; else this._value = v == 1 ? true : v;

  // Since we use model 'value', we can rely on standard write.
  // However, if we need to enforce 'useNull' or type coercion when VALUE IS SET FROM OUTSIDE (Input),
  // we might need an effect or input transform on the base class?
  // Base class 'value' is a model.

  // If we want to transform the value when it comes in:
  override onInternalValueSet(v: any) {
    let newValue = v;
    if (!newValue) {
      newValue = this.useNull() ? null : false;
    } else if (typeof newValue !== 'boolean') {
      // Original: this._value = v == 1 ? true : v;
      if (typeof newValue === 'number')
        newValue = newValue == 1 ? true : newValue;
      if (typeof newValue === 'string') newValue = newValue === 'true';
    }

    return newValue;
  }
}
